import { useQuery } from "@tanstack/react-query";
import type { VehicleUpload, Generation } from "@/lib/db/schema";

interface VehicleUploadWithGenerations extends VehicleUpload {
  generations: Pick<Generation, "id" | "status" | "createdAt">[];
}

interface VehicleUploadsResponse {
  uploads: VehicleUploadWithGenerations[];
}

async function fetchVehicleUploads(): Promise<VehicleUploadsResponse> {
  const response = await fetch("/api/vehicles");
  if (!response.ok) {
    throw new Error("Failed to fetch vehicle uploads");
  }
  return response.json();
}

export function useVehicleUploads() {
  return useQuery({
    queryKey: ["vehicle-uploads"],
    queryFn: fetchVehicleUploads,
    staleTime: 2 * 60_000,
    gcTime: 10 * 60_000,
    retry: 1,
  });
}
